import { getApiBaseUrl } from '../../api/config';

/**
 * Matches listing/show API: GET .../companies?relations[0]=author&relations[2]=status&relations[3]=currency
 * (indexes are intentional — backend uses [0], [2], [3].)
 */
export const COMPANY_RELATIONS = {
  'relations[0]': 'author',
  'relations[2]': 'status',
  'relations[3]': 'currency',
};

export const buildCompanyRelationParams = () => ({ ...COMPANY_RELATIONS });

export const resolveCompanyLogoUrl = (logo) => {
  if (logo == null || logo === '') return '';
  if (typeof logo === 'object' && logo?.url) return resolveCompanyLogoUrl(logo.url);
  const s = String(logo);
  if (/^https?:\/\//i.test(s)) return s;
  const base = (getApiBaseUrl() || '').replace(/\/$/, '');
  if (!base) return s;
  return s.startsWith('/') ? `${base}${s}` : `${base}/${s}`;
};
